/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */

import React from 'react'

import { SelectedNamesSummary } from '../permissions/SelectedNamesSummary'
import type { AdminUserSummary } from '../types'

/** Who the change will apply to. */
export const SelectedUsersSummary: React.FC<{ users: AdminUserSummary[] }> = ({ users }) => (
  <SelectedNamesSummary
    noun="users"
    data-testid="selected-users"
    items={users.map((user) => ({ key: user.uid, label: user.email, title: user.uid }))}
  />
)

export default SelectedUsersSummary
